<template>
  <div class="d-flex justify-content-between align-items-center">
    <eg-button
      v-b-toggle.source-material-sidebar
      type="secondary"
      icon="plus-add-more-maximize"
      icon-size="medium"
    >
      {{ $t("materials.selectMaterial") }}
    </eg-button>
  </div>
</template>

<script>
export default {
  name: "SourceMaterialButton",
};
</script>
